import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'
import linkify from '../utils/linkify'

const StyledLinkDark = linkify(styled.a``, 'dark')
const StyledLinkLight = linkify(styled.a``, 'light')

interface IProps {
  href: string
  text: string
}

export const InlineLinkDarkControl = (props: PropsWithChildren<IProps>) => (
  <StyledLinkDark href={props.href} target="_blank" rel="noopener noreferrer">
    {props.text}
  </StyledLinkDark>
)

export const InlineLinkLightControl = (props: PropsWithChildren<IProps>) => (
  <StyledLinkLight href={props.href} target="_blank" rel="noopener noreferrer">
    {props.text}
  </StyledLinkLight>
)

export default InlineLinkDarkControl
